const newzooByMonth = '用户活跃指标目前按月更新。';
const retentionDetailInfo = (dn: string) =>
  `首次登入游戏后${dn}天再次登入的新玩家百分比。 `;
const newzooTimeSpentDetialInfo = (start: string, end: string) =>
  `在一个月内，花费${start}到${end}小时玩一款游戏的玩家百分比。`;
const dbi_info_max_selected = '取所选时间段内的最大值。';
const dbi_info_avg_selected = '取所选时间段内的平均值。';
const dbi_info_sum_selected = '取所选时间段内的总值。';
const dbi_info_weighted_avg = `取所选时间段内的加权平均值。`;

const dbi_info_player_share = `在选定时间段内玩过某款游戏的玩家占玩家总数的百分比。`;
const dbi_info_mau_growth = `月活总量逐月增长。`;
const dbi_info_mau_new = `在所选时间段内首次玩该游戏的月度总玩家数(已去重）。`;
const dbi_info_mau_returning = `在所选时间段之前玩过该游戏的月度总玩家数（已去重）。`;
const dbi_info_lifetime_player = `截止到指定时间段内玩过该游戏的总玩家数（已去重）。`;
const dbi_info_avg_daily_playtime = `平均玩家每天的平均游戏时间。`;
const dbi_info_avg_daily_sessions = `所选时间段内活跃玩家的日平均游戏登入次数（总登入数/月活/平均游戏天数）。`;
const dbi_info_avg_days_played = `活跃玩家每月平均游戏天数。`;
const dbi_info_avg_monthly_playtime = `所选时间段内活跃玩家的月平均游戏时长（总时长/月活）。`;
const dbi_info_avg_monthly_sessions = `在所选时间段内，每个玩家在玩家细分中的平均场次。`;
const dbi_info_avg_playtime_per_session = `在所选时间段内，活跃玩家每次游戏的平均时长（总时长/总游戏时长）。`;
const dbi_info_stickiness = `玩家每天玩某款游戏的可能性。我们使用以下计算方法来了解用户的粘性：（日活跃用户数/月活跃用户数）x 100，所得 百分比越高，用户粘性越强。`;
const dbi_info_total_hours = `所选时间段内所有玩家的游戏总耗时。总耗时以玩家启动游戏并运行的时长来定义。`;
const dbi_info_churn = `在所选时间段内没玩过游戏但在前一个月内玩过此游戏的玩家百分比。`;
const dbi_info_acquisition = `在所选时间段内玩了这款游戏但前一个月并没有玩游戏的玩家百分比。`;
const dbi_info_time_spent = `在一个月内，花费{start}到{end}小时玩一款游戏的玩家百分比。`;
const dbi_info_time_spent_50H = `当月游玩时长超过50小时的玩家占比。`;
const dbi_info_retention_dn = `首次登入游戏后{dn}天再次登入的新玩家百分比。`;
const dbi_info_rpd_cumulative = '取累计收入除以选定时间段内的累计下载量。';
const dbi_info_retention_trend =
  '用户在第一次启动应用程序后的第{dn}天再次打开该应用程序的百分比。';

export default {
  dbi_info_global_filter:
    '全球：显示全球各国的总值。它是直接取全球规模，而非下方所有可选国家的汇总值。',
  dbi_info_global_filter2: '全球： 显示以下国家的汇总值。',
  dbi_info_global_filter3:
    '全球: 这里显示下面所有可用国家/地区的合计值。 提供70 个国家/地区的手机游戏数据以及美英法德西的 PC 和主机游戏数据。',
  dbi_info_global_filter_mobile:
    '全球：展示全球整体数据。直接通过统计模型所得，不是所有国家的加总。',
  dbi_info_global_tips_store_rank_top: '全球：展示全球整体数据。',
  dbi_info_global_filter_notmobile:
    '对于MScience数据是5个国家的加总/加权平均值。对于GSD数据是13个国家的加总/加权平均值 （并非所有国家都有全部游戏）。对于活跃数据，是37个国家的月活加权平均值。',
  dbi_info_global_wo_china_filter:
    '全球（不含中国大陆）：展示不含中国大陆的全球汇总数据，当前仅 Other Vendor 数据源支持该地区口径。',
  dbi_info_global_tips_store_rank_mobile_detail:
    '全球: 展示游戏在全球70个国家的商店排名。',
  dbi_info_global_wo_china_tips_store_rank_mobile_detail:
    '海外: 展示游戏在全球（不包括中国大陆）的69个国家的商店排名。',
  dbi_info_global_tips_store_rank_mobile_detail_market: `全球：展示游戏在全球70个国家商店排名为1-3、4-10、11-50和51-100区间的国家数量分布。`,
  dbi_info_global_tips_store_rank_combine_detail_rank_trend: `国家排名趋势： 选择全球会展示全球榜单&各个国家榜单，全球榜单直接爬取自Steam网站，显示Global排名。
市场份额分布：选择全球会分别展示各个国家的榜单数据，不包括全球榜单`,
  dbi_info_global_wo_china_tips_store_rank_mobile_detail_market: `全球（不包括中国大陆）：展示游戏在全球（除中国大陆之外）69个国家商店排名在1-3，4-10，11-50，51-100区间的国家个数分布。`,
  dbi_info_max_selected,
  dbi_info_avg_selected,
  dbi_info_sum_selected,
  dbi_info_acu_avg: 'ACU是平均同时在线用户。取所选时间段内的平均值。',
  dbi_info_units_indicates: `"销量"表示交易数量，类型为"全部 "的销量比其他部分的单位总和要小。因为单笔交易可能包括完整游戏和付费扩展包等。取选定国家的总值。取所选时间段内的总值。`,
  dbi_info_units_sold: `由 Mscience 提供的电子版销量。美国通常占全球总销量的 50%。包含游戏本体的捆绑包或版本将识别为游戏本体，而不是拓展包或微交易。{br}默认展示的数据为美国市场数据，这是由于美国市场的抽样数据量更为充分。而对于欧洲等市场，由于抽样数据量相对较小，分析时建议谨慎参考使用。`,
  dbi_info_genreprofile_revenue_tip: `Daily revenue指选定时间段内的每日收入。Data.ai展示从总收入中扣除30%基本费用的净收入。全球范围内，仅提供来自App Store和Google Play商店的数据，不包含任意其他第三方应用商店的数据。所选时段范围内取Sum值`,
  dbi_info_appannie_revenue_tip: `总收入由data.ai来源的手游收入、NPD数据源PC&Console游戏的零售收入数据和Mscience数据源PC&Console游戏的线上收入数据汇总得来。`,
  // dbi_info_sensortower_revenue_tip: `Revenue指衡量应用程序的净收入，且将每个国家/地区的税收因素考虑在内。净收入已扣除30%的商店基本费用。全球范围内，仅提供来自App Store和Google Play商店的数据，不包含任意其他第三方应用商店的数据。`,
  dbi_info_sensortower_revenue_tip: `Revenue指衡量应用程序的净收入，且将每个国家/地区的税收因素考虑在内。净收入已扣除30%的商店基本费用。仅提供App Store和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。`,
  // dbi_info_appannie_downloads_tip: `Daily downloads指选定时间段内的每日下载量。下载量数据直接与应用商店的用户账号相关联，意指不包括app更新，app重新安装，出厂设置app预安装，以及用户账号在新设备的安装。全球范围内，仅提供来自App Store和Google Play商店的数据，不包含任意其他第三方应用商店的数据。所选时段范围内取Sum值。`,
  dbi_info_appannie_downloads_tip: `Daily downloads指选定时间段内的每日下载量。下载量数据直接与应用商店的用户账号相关联，意指不包括app更新，app重新安装，出厂设置app预安装，以及用户账号在新设备的安装。仅提供App Store和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。所选时段范围内取Sum值。`,
  // dbi_info_sensortower_downloads_tips: `Downloads指一个用户账号在应用商店里进行的唯一下载及安装。下载量不包括长时间不活跃后重新安装app，卸载后重新安装以及同一用户在新设备上进行的安装操作。`,
  dbi_info_sensortower_downloads_tips: `Downloads指一个用户账号在应用商店里进行的唯一下载及安装。下载量不包括长时间不活跃后重新安装app，卸载后重新安装以及同一用户在新设备上进行的安装操作。仅提供App Store和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。所选时段范围内取Sum值。`,
  dbi_info_digital_revenue_tip: `由 Mscience 提供的电子版游戏收入。美国通常占全球总收入的 50%。{br}默认展示的数据为美国市场数据，这是由于美国市场的抽样数据量更为充分。而对于欧洲等市场，由于抽样数据量相对较小，分析时建议谨慎参考使用。`,
  dbi_info_monthly_digital_revenue_genre_profile__tip: `显示最新的月度电子版收入，上月数据在每月 5 日前后更新。`,
  dbi_info_physical_revenue_tip: `指线下零售购买的硬件版游戏总收入。`,
  dbi_info_monthly_physical_revenue_genre_profile__tip: `显示最新的每月实体收入，上月数据在每月 20 日前后更新。`,
  dbi_info_total_revenue:
    '总收入由Sensor Towwer来源的手游收入、NPD数据源PC&Console游戏的零售收入数据和Mscience数据源PC&Console游戏的线上收入数据汇总得来。',
  dbi_info_arppu_usonly: `${dbi_info_avg_selected}电子版每付费用户平均收收益仅适用于美国市场。`,
  dbi_info_arppu_usonly2: `${dbi_info_avg_selected}该指标仅适用于美国市场。`,
  dbi_info_weighted_avg,
  dbi_info_ast_average: `AST是每次交易的平均支出。${dbi_info_weighted_avg}`,
  dbi_info_est_revenue: `仅Steam游戏收入(美元)，根据Stearm评论估算，这里的VGI只包括游戏本体的收入，不包括付费扩展包和微交易数据，因此不提供免费游戏的收入。{br}用户可以参考Mscience提供的线上收入数据，查看单款游戏的本体收入数据，可以按照本体游戏、微交易、付费扩展包等不同细分数据进行拆分。`,
  dbi_info_gamalytic_est_revenue: `仅Steam游戏收入(美元)，根据Steam评论量级、公开榜单等数据进行估算，Gamalytic包括预售收入，对付费游戏估算本体销售收入，不包含GaaS收入；对免费游戏估算包含GaaS部分的整体收入`,
  dbi_info_gamalytic_est_cumulative_revenue: `仅Steam游戏累计收入(美元)，根据Steam评论量级、公开榜单等数据进行估算，Gamalytic包括预售收入，对付费游戏估算本体销售收入，不包含GaaS收入；对免费游戏估算包含GaaS部分的整体收入`,
  dbi_info_est_units: `根据Steam评论估算，只提供Steam游戏销量。{br}这里仅提供完整游戏的销量，因此付费游戏的数据可信度相对高于免费游戏。{br}用户可以参考Mscience提供的电子版收入来查看单款游戏的整体销售数据，这些数据可以按照完整游戏、微交易、付费扩展包等不同细分来划分。`,
  dbi_info_est_price: `该游戏的每日价格（美元），如果选择周或月，则取平均值。`,
  dbi_info_weighted_price: `该游戏的加权价格（美元）是根据每日售出单位计算得出的。`,
  dbi_info_players_by_country: `根据评论语言得出的玩家国家分布。`,
  dbi_info_playtime: `每位玩家在这款游戏上花费的总平均时间（分钟）。`,
  dbi_info_vgi_playtime: `每位玩家在这款游戏上花费的总平均时间（分钟）。`,
  dbi_info_followers: `截至目前该游戏的总粉丝数。`,
  dbi_info_revenue_removed: `取所选时间段内的总值。收入已从应用内购买、订阅和付费应用下载中移除30%的佣金。`,
  dbi_info_revenue_removed_new: '收入默认不包括从应用内购买、订阅和付费应用下载佣金（约30%）。可通过筛选器收入范围调整。',
  dbi_info_download_tip:
    '下面显示的是汇总值。如果你想看到按国家或时间分列的数据，请下载数据并选择对应选项。',
  dbi_info_dataai_genre: `这系列主品类和子品类是由data.ai提供的。`,
  dbi_info_iegg_genre: `手游的IEGG品类标签由游戏研究中心专家基于数据库数据综合评估后提供。`,
  dbi_info_sensortower_genre:
    '该品类体系来自 Sensor Tower 的 Game IQ 模块，主要基于核心玩法进行游戏品类与子品类的划分。例如：卡牌游戏（如 UNO）会被归入“休闲与解谜”大类之下；而扑克及其他具备博彩功能的卡牌游戏，则被归入“赌场”类别。',
  dbi_info_mau_represents: `表示在选定月份内至少玩过一次某游戏的用户数量。${newzooByMonth}计算方式是取平均数。`,
  dbi_info_newzoo_bymonth: newzooByMonth,
  dbi_info_newzoo_calculate_method: `计算方式是取平均数。`,
  dbi_info_newzoo_mau_genre_profile_tip: `显示最新的 MAU，每月 10 日左右更新上月数据。`,
  dbi_info_newzoo_mau_tip: `MAU指在给定月份中至少启动过一次游戏的用户数量。既为玩过该品类游戏的总月度玩家数。所选时段范围内取Avg值。`,
  // dbi_info_appannie_mau_tip: `MAU指所选时段内每月活跃用户量，MAU数据根据合作伙伴提供的真实样本数据按比例放大。所选时段范围内取Avg值。`,
  dbi_info_appannie_mau_tip: `MAU指所选时段内每月活跃用户量，MAU数据根据合作伙伴提供的真实样本数据按比例放大。仅提供App Store和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。所选时段范围内取Avg值。`,
  // dbi_info_sensortower_mau_tip: `MAU指当月至少登录过一次的所有用户总数。所选时段范围内取Avg值。`,
  dbi_info_sensortower_mau_tip: `MAU指当月至少登录过一次的所有用户总数。仅提供App Store和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。所选时段范围内取Avg值。`,
  dbi_info_player_share: dbi_info_player_share + newzooByMonth,
  dbi_info_mau_growth: dbi_info_mau_growth + newzooByMonth,
  dbi_info_mau_new: dbi_info_mau_new + newzooByMonth,
  dbi_info_mau_returning: dbi_info_mau_returning + newzooByMonth,
  dbi_info_lifetime_player: dbi_info_lifetime_player + newzooByMonth,
  dbi_info_avg_daily_playtime: dbi_info_avg_daily_playtime + newzooByMonth,
  dbi_info_avg_daily_sessions: dbi_info_avg_daily_sessions + newzooByMonth,
  dbi_info_avg_days_played: dbi_info_avg_days_played + newzooByMonth,
  dbi_info_avg_monthly_playtime: dbi_info_avg_monthly_playtime + newzooByMonth,
  dbi_info_avg_monthly_sessions: dbi_info_avg_monthly_sessions + newzooByMonth,
  dbi_info_avg_playtime_per_session:
    dbi_info_avg_playtime_per_session + newzooByMonth,
  dbi_info_stickiness: dbi_info_stickiness + newzooByMonth,
  dbi_info_total_hours: dbi_info_total_hours + newzooByMonth,
  dbi_info_churn: dbi_info_churn + newzooByMonth,
  dbi_info_acquisition: dbi_info_acquisition + newzooByMonth,
  dbi_info_time_spent: dbi_info_time_spent + newzooByMonth,
  dbi_info_time_spent_50H: dbi_info_time_spent_50H + newzooByMonth,

  dbi_info_player_share_detail: dbi_info_player_share,
  dbi_info_mau_growth_detail: dbi_info_mau_growth,
  dbi_info_mau_new_detail: dbi_info_mau_new,
  dbi_info_mau_returning_detail: dbi_info_mau_returning,
  dbi_info_lifetime_player_detail: dbi_info_lifetime_player,
  dbi_info_avg_daily_playtime_detail: dbi_info_avg_daily_playtime,
  dbi_info_avg_daily_sessions_detail: dbi_info_avg_daily_sessions,
  dbi_info_avg_days_played_detail: dbi_info_avg_days_played,
  dbi_info_avg_monthly_playtime_detail: dbi_info_avg_monthly_playtime,
  dbi_info_avg_monthly_sessions_detail: dbi_info_avg_monthly_sessions,
  dbi_info_avg_playtime_per_session_detail: dbi_info_avg_playtime_per_session,
  dbi_info_stickiness_detail: dbi_info_stickiness,
  dbi_info_total_hours_detail: dbi_info_total_hours,
  dbi_info_churn_detail: dbi_info_churn,
  dbi_info_acquisition_detail: `获客% 是游戏获得的玩家在该类型所有玩家中所占的百分比。${dbi_info_weighted_avg}`,
  dbi_info_time_spent_detail: dbi_info_time_spent,
  dbi_info_time_spent_50H_detail: dbi_info_time_spent_50H,
  dbi_info_retention_dn: dbi_info_retention_dn + newzooByMonth,
  dbi_info_retention_dn_detail: dbi_info_retention_dn,
  dbi_info_rpd_cumulative: dbi_info_rpd_cumulative + newzooByMonth,
  dbi_info_rpd_cumulative_detail: dbi_info_rpd_cumulative,
  dbi_info_retention_trend: dbi_info_retention_trend + newzooByMonth,
  dbi_info_retention_trend_detail: dbi_info_retention_trend,

  // dbi_info_retention_trend_nd: '用户在第一次启动应用程序后的第{dn}天再次打开该应用程序的百分比。',
  // dbi_info_retention_trend_th: '用户在第一次启动应用程序后的第{dn}天再次打开该应用程序的百分比。',
  // dbi_info_retention_trend_st: '用户在第一次启动应用程序后的第{dn}天再次打开该应用程序的百分比。',
  dbi_info_retention_d15: `data.ai只能提供第15天的留存数据，所以没有data.ai D14 (双周留存)。`,
  dbi_info_retention_d31: `data.ai只能提供第31天的留存数据，所以没有data.ai D30 (月留存).`,
  dbi_info_revenue_ofcompany: `这里显示的是游戏收入占公司总收入的百分比。`,
  dbi_info_downloads_ofcompany: `这里显示的是游戏收入占公司总下载的百分比。`,
  dbi_info_company_revenue_filter: `这里显示的是该公司发布的所有游戏的总收入。`,
  dbi_info_company_downloads_filter: `这里显示的是该公司发布的所有游戏的总下载。`,
  dbi_info_pheat_items_are_listed: `条目默认按该指标降序排列。请选择条目，仅用于选择信息。`,
  dbi_info_pheat_the_predicted_value: `P.Heat：即将上线的游戏预测值，基于对发行商的各种指标的统计算法分析。`,
  dbi_info_pheat_the_parameter_factors: `P.Heat值的参数因素包括国家权重和游戏类别，以及开发商和发行商的过往表现，如收入和利润。PC游戏也受到steam Top Wishlist的影响。`,
  dbi_info_pheat: `根据对发行商各项数据指标通过NLP算法模型分析，预估新游的潜力值。`,
  dbi_info_appstore_topfree: `Top Free榜单是App Store下载量最高的免费应用程序榜单。`,
  dbi_info_googleplay_topfree: `Top Free榜单是Google Play下载量最高的免费应用程序榜单。`,
  dbi_info_googleplay_topgrossing: `Top Grossing榜单是Google Play应用程序内收入最高的应用程序榜单。`,
  dbi_info_appstore_topgrossing: `Top Grossing榜单是App Store应用程序内收入最高的应用程序榜单。`,
  dbi_info_appstore_top_paid: `Top Paid榜单是App Store下载量最高的付费应用榜单。`,
  dbi_info_googleplay_topnewfree: `Top New Free榜单是30天内Google Play下载量最高的免费应用程序榜单。`,
  dbi_info_googleplay_toppaid: `Top Paid榜单是Google Play下载量最高的付费应用榜单。`,
  dbi_info_googleplay_topnewpaid: `Top New Paid榜单是30天内Google Play下载量最高的付费应用榜单。`,
  dbi_info_steam_topsellers: `Top Sellers榜单是Steam平台畅销游戏榜单。`,
  dbi_info_epic_topsellers: `Top Sellers榜单是Epic平台畅销游戏榜单。`,
  dbi_info_epic_toppopular: `Top Popular榜单是Epic平台热门游戏榜单。`,
  dbi_info_xbox_newrelease: `New release榜单是Xbox平台热门新游榜单。`,
  dbi_info_xbox_upcoming: `Upcoming榜单是Xbox平台即将上线热门游戏榜单。`,
  dbi_info_xbox_mostplayed: `Most played榜单是Xbox平台游戏登录最多的游戏榜单。`,
  dbi_info_steam_newtrending: `New & Trending榜单是Steam平台热门新游榜单。`,
  dbi_info_steam_topwishlists: `Top Wishlists榜单是Steam平台添加愿望单次数最多的游戏榜单。`,
  dbi_info_release_time: '这里显示所有来源的最新发布日期。',
  dbi_info_average_mau: `分别基于选定时间段内和现有国家的平均月活。`,
  dbi_info_mau_rank: `这里显示的是所选国家中月活排行榜最高的排名。`,
  dbi_info_revenue_arpu: `ARPU： 每个活跃用户的平均收入，直接用收入除以活跃用户。`,
  dbi_info_fullgame_nodata: `当前过滤选项下无数据或该游戏为免费游戏，请更改细分选项以查看其微交易/付费拓展包 数据。`,
  dbi_info_unitsfullgame_nodata: `当前过滤选项下无数据或该游戏为免费游戏，请更改细分选项为全部以查看其总收入。`,
  dbi_info_following_retention: `留存指标只有在时间筛选器选择单月时可用。`,
  dbi_info_steam_pcu_genre_profile_tip: `显示最新的 PCU，数据更新延迟 1 天。`,
  dbi_info_steam_pcu_tip: `PCU指Steam平台上该游戏同时在线人数的峰值。所选时段范围内取Max值。`,
  dbi_info_following_mobile_title: `Sensor Tower与data.ai应用的算法模型不一致，在各个市场投入的成本资源不同（例如Sensor Tower在东南亚市场的投入相比annie会更高，而data.ai对于国家地区的资源倾斜第一梯队是美国、中国、日本，第二梯队是法国、德国、意大利、西班牙、英国、墨西哥、巴西、印度、俄罗斯、加拿大、韩国、澳大利亚、中国台湾、新加坡，其余国家为第三梯队），因此数据存在差异。`,
  dbi_info_newgames_pheat: `根据对发行商各项数据指标通过数据科学模型分析，预估新游的潜力值.`,
  dbi_info_streaming_peakccv: `这里显示的是同时在线观看人数的峰值。`,
  dbi_info_following_disable_mobile: `排名和评分指标仅在选择单日和单个国家时可用。`,
  dbi_info_following_disable_onlymonth: `{metric}指标仅在月粒度下可用。`,
  dbi_info_following_disable_famitsu: `{famitsu}指标仅在选择周粒度和日本市场时可用。`,
  dbi_info_following_disable_retention: `留存指标只有在时间筛选器选择单月时可用。`,
  dbi_info_following_disable_retention_st: `留存指标只有在时间筛选器选择单月时可用。`,
  dbi_info_following_disable_onlyglobal: `{metric}指标仅在选择全球方案下可用`,
  dbi_info_following_disable_pcconsole: `排名和评级指标仅在选择单日和全球方案时可用。`,
  dbi_info_following_manage_btn: `在这里，您可以管理自己关注的游戏。`,
  dbi_info_following_table_digital: `如果电子版收入中没有数据，请尝试将上述时间维度转换为月份。`,
  dbi_info_demographics_click_particular: `点击这里查看该游戏下更多细分版本分别的用户画像数据。`,
  dbi_info_pcu: `PCU是最高同时在线玩家人数。取所选时间段内最大值。`,
  dbi_info_pcconsole_timefilter: `发布日期筛选器：各个title取的是最早的发行日期`,
  dbi_retention_d1: '留存 D1',
  dbi_retention_d2: '留存 D2',
  dbi_retention_d4: '留存 D4',
  dbi_retention_d7: '留存 D7',
  dbi_retention_d14: '留存 D14',
  dbi_retention_d28: '留存 D28',
  dbi_info_retention_d1: retentionDetailInfo('1') + newzooByMonth,
  dbi_info_retention_d2: retentionDetailInfo('2') + newzooByMonth,
  dbi_info_retention_d4: retentionDetailInfo('4') + newzooByMonth,
  dbi_info_retention_d7: retentionDetailInfo('7') + newzooByMonth,
  dbi_info_retention_d14: retentionDetailInfo('14') + newzooByMonth,
  dbi_info_retention_d28: retentionDetailInfo('28') + newzooByMonth,
  dbi_info_retention_d60: retentionDetailInfo('60') + newzooByMonth,
  dbi_info_retention_detail_d1: retentionDetailInfo('1'),
  dbi_info_retention_detail_d2: retentionDetailInfo('2'),
  dbi_info_retention_detail_d4: retentionDetailInfo('4'),
  dbi_info_retention_detail_d7: retentionDetailInfo('7'),
  dbi_info_retention_detail_d14: retentionDetailInfo('14'),
  dbi_info_retention_detail_d28: retentionDetailInfo('28'),
  dbi_info_retention_detail_d60: retentionDetailInfo('60'),
  dbi_info_timespent_01: newzooTimeSpentDetialInfo('0', '1') + newzooByMonth,
  dbi_info_timespent_15: newzooTimeSpentDetialInfo('1', '5') + newzooByMonth,
  dbi_info_timespent_510: newzooTimeSpentDetialInfo('5', '10') + newzooByMonth,
  dbi_info_timespent_1025:
    newzooTimeSpentDetialInfo('10', '25') + newzooByMonth,
  dbi_info_timespent_2550:
    newzooTimeSpentDetialInfo('25', '50') + newzooByMonth,
  dbi_info_timespent_detail_01: newzooTimeSpentDetialInfo('0', '1'),
  dbi_info_timespent_detail_15: newzooTimeSpentDetialInfo('1', '5'),
  dbi_info_timespent_detail_510: newzooTimeSpentDetialInfo('5', '10'),
  dbi_info_timespent_detail_1025: newzooTimeSpentDetialInfo('10', '25'),
  dbi_info_timespent_detail_2550: newzooTimeSpentDetialInfo('25', '50'),

  dbi_timefilter_info: `时间筛选器： 更改时间粒度来获得更多数据指标。例如，将 WAU 的粒度设为 "周"。`,
  dbi_weixin_filter_info: `当日最新入榜数据的英文版可能存在翻译延迟，预计将于次日更新显示。`,
  dbi_douyin_filter_info: `抖音游戏榜单仅代表中国大陆区 App 数据，不包含 TikTok。<br/>今日新增内容的英文翻译可能会有延迟，将于次日提供。`,
  dbi_timefilter_mscience_info: `当前默认展示美国区游戏本体的数据。Time Filter: Mscience日粒度数据仅适用于美国。`,
  dbi_genrefilter_info: `品类筛选器： 自 2020 年以来，在主要国家/地区总收入排名前 85% 的游戏和全球排名前 92% 的游戏都会应用品类标签。`,
  dbi_roblox_genrefilter_info:
    'Roblox 品类源自开发者后台填报，经平台官方审核校准，依据游戏核心循环玩法划分。',
  dbi_roblox_top_charts_metric_players_tip: '体验游玩该游戏的用户总数量',
  dbi_roblox_top_charts_metric_visits_tip: '游戏页面被用户浏览访问总次数',
  dbi_roblox_top_charts_metric_likes_tip: '统计游戏累计获得的点赞总量',
  dbi_roblox_top_charts_metric_dislikes_tip: '统计游戏累计收到的差评点踩数量',
  dbi_roblox_top_charts_metric_favorites_tip: '用户将该游戏加入收藏的累计数量',
  dbi_roblox_top_charts_metric_pcu_tip: '统计时段内游戏在线玩家人数峰值',
  dbi_roblox_top_charts_metric_max_players_tip: '统计时段内游戏在线玩家人数峰值',
  dbi_roblox_server_size_tip: '单局服务器可容纳的最大同时游玩人数',
  dbi_roblox_supported_features_tip: '游戏内支持的交互式内置功能',
  dbi_releasedatefilter_info: `发布日期筛选器： 为获得更好的体验，该筛选器仅在有效时间范围内可用。`,
  dbi_sentowerfilter_info:
    'Sensor Tower Tags筛选器：艺术风格、镜头视角、产品模型、设定、游戏标签、盈利模式和主题等标签来自Sensor Tower。',
  dbi_first_follow_info: `单击此处进入游戏详情页，您可以访问详细的统计数据并关注该游戏。`,
  dbi_xbox_newrelease_info: `New release榜单是Xbox平台热门新游榜单。`,
  dbi_steam_newtrending_info: `New & Trending榜单是Steam平台热门新游榜单。`,
  dbi_nintendo_newgames_info: `商店排名 - 新游戏：Playstation 上新发布的游戏。`,
  dbi_steam_topwishlists_info: `Top Wishlists榜单是Steam平台添加愿望单次数最多的游戏榜单。`,
  dbi_retention_edition_nd_info:
    '这里显示的是在所选时间范围内所有可用版本基于 MAU 的月留存率{dn}平均值。',
  dbi_retention_countries_nd_info:
    '这里显示的是在所选时间范围内，基于所有可用国家/地区 MAU 的月留存率{dn}平均值。',
  dbi_retention_monthly_sensortower_avg_dx_hover: `这里显示的是在所选时间范围内所有可用版本基于 MAU 的月留存率{metric}平均值。
仅提供AppStore和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据.`,
  dbi_info_retention_monthly_region_filter_hover:
    '多选国家时，将按各国家的月活跃用户数进行加权平均计算留存率。',
  dbi_info_retention_monthly_platform_filter_hover:
    '单选平台时，将按该平台不同包体的月活跃用户数进行加权平均计算留存率。',
  /** Sensor Tower 月度留存表头悬浮；{metric} 为当前列 Dn（如 D2、D7），{day} 为对应天数 */
  dbi_retention_monthly_sensortower_dx_hover: `指标含义：用户首次启动应用后，{day}天留存周期内至少打开过一次 App 的用户占比，不要求用户在该周期内每天都活跃。单月按安装日期将用户划分为不同安装组别计算留存，再将各组结果聚合为月度加权平均值

    时间粒度：月

    更新时间：月留存数据于次月 7 号更新，{metric} 数据会在次月末前动态修正

    时间段计算方式：多月取MAU加权平均值

    数据来源：仅覆盖 App Store、Google Play 官方平台数据，不包含中国大陆安卓渠道及第三方渠道数据
  `,
  dbi_detail_earlistdate_info: `对于部分发行日期早于2016年或取得了较好公测结果的游戏，其最早数据的日期会与游戏发行日期不一致。`,
  dbi_detail_earlistdate_info_pcconsole: `用户活跃指标：PC 和主机的数据分别从 2020年 12月和 2020年 4月开始提供。这可能导致 PC 和主机游戏在这些月份的增长率激增。对于部分发行日期早于2016年或取得了较好公测结果的游戏，其最早数据的日期会与游戏发行日期不一致。`,
  dbi_stats_segement_info: `Sensor Tower与data.ai应用的算法模型不一致，在各个市场投入的成本资源不同（例如Sensor Tower在东南亚市场的投入相比annie会更高，而data.ai对于国家地区的资源倾斜第一梯队是美国、中国、日本，第二梯队是法国、德国、意大利、西班牙、英国、墨西哥、巴西、印度、俄罗斯、加拿大、韩国、澳大利亚、中国台湾、新加坡，其余国家为第三梯队），因此数据存在差异。`,
  dbi_stats_segement_retention_info: `data.ai 的留存率汇总到月。Sensor Tower 的留存率汇总到 2015 年第四季度以来的所有时间。`,
  dbi_stats_filter_dropdown_info: `这个游戏在某些时间段从所选国家的前1000名内掉榜，因此你会在下面的折线图中看到数据断层。`,
  dbi_country_revenue_sum_info: `这里显示的是所选时间范围内所有国家/地区的收入总值。`,
  dbi_country_revenue_avg_info: `这里显示的是所选时间范围内所有国家/地区的平均收入值。`,
  dbi_country_dowload_sum_info: `这里显示的是所选时间范围内所有国家/地区的下载量总值。`,
  dbi_country_dowload_avg_info: `这里显示在所选时间范围内所有国家/地区的下载平均值。`,
  dbi_edition_revenue_sum_info: `这里显示所选时间范围内所有版本的收入总值。`,
  dbi_edition_revenue_avg_info: `这里显示所选时间范围内所有版本的平均收入值。`,
  dbi_edition_dowload_sum_info: `此处显示所选时间范围内所有版本的平均下载值。`,
  dbi_edition_dowload_avg_info: `此处显示所选时间范围内所有版本的下载总值。`,
  dbi_country_activeuser_info: `这里显示的是所选时间范围内所有国家/地区的{dateType}活跃用户值。`,
  dbi_edition_activeuser_info: `这里显示的是所选时间范围内所有版本的{dateType}活跃用户数值。`,
  dbi_gameselected_err_info: `很抱歉，当前页签中没有您选择的游戏。`,
  dbi_gameselected_reset_info: `游戏列表将重置为默认状态。`,
  dbi_metrictable_pc_game_info: `指标宽表包含多个平台的PC游戏，提供游戏相关的所有可用指标。默认以Steam PCU降序排列。`,
  dbi_metrictable_console_game_info: `指标宽表包含多个平台的主机游戏，提供游戏相关的所有可用指标。默认以线上收入降序排列。`,
  dbi_metric_databrain_info1:
    'DataBrain校准数据：点击游戏名称下钻查看校准DAU、下载、收入，宽表现仅展示data.ai及Sensor Tower数据',
  dbi_metric_databrain_info: `DataBrain校准数据主要来自算法模型预测，输入考虑的因素有渠道打听的竞品真实数据、内部部分分国家真实数据、商店排名、Annie Sensor tower数据趋势等等。有任何竞品表现数据反馈欢迎随时联系ivyyfchen。`,
  // dbi_metric_appannie_info: `Annie提供收入、下载量和活跃用户等关键指标。收入为已扣除30%渠道费的净收入。仅提供AppStore和Google play平台数据。`,
  dbi_metric_appannie_info: `Annie提供收入、下载量和活跃用户等关键指标。收入为已扣除30%渠道费的净收入。仅提供AppStore和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。`,
  dbi_metric_publisher_shared: `发行商直接分享的游戏销售数据。`,
  dbi_metric_publisher_retail: `零售商及分销商提供的游戏零售数据，并非发行商提供。`,
  dbi_metric_publisher: `GSD发行商分享数据`,
  dbi_metric_publisher_All_value: `全部数据`,
  dbi_metric_publisher_shared_value: `分享数据`,
  dbi_metric_publisher_retail_value: `零售数据`,
  // dbi_metric_sensortower_info: `Sensor tower提供收入、下载量和活跃用户等关键指标。收入为已扣除30%渠道费的净收入。仅提供AppStore和Google play平台数据。`,
  dbi_metric_sensortower_info: `Sensor tower提供收入、下载量和活跃用户等关键指标。收入为已扣除30%渠道费的净收入。仅提供AppStore和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。`,
  dbi_mscience_info: `查看游戏本体收入，请选择Segment为Base Game。默认选择All是为了兼容免费游戏和付费游戏。日粒度数据仅支持美国。`,
  dbi_mscience_global_info: `查看游戏本体收入，请选择Segment为Base Game。默认选择All是为了兼容免费游戏和付费游戏。日粒度数据仅支持美国。`,

  dbi_detail_feedback_tips:
    '您可以填写您所知道的更准确的游戏数据或任何有关 DataBrain 的反馈。例如 2024 年 1 月，该游戏在美国的收入为 100w。',

  dbi_info_nofollowing_lets: `还没有关注的{type}，让我们关注一些{follow}吧.`,
  dbi_info_followsome_game: `{type}`,
  dbi_info_follow_top_charts: `或者在{type}点击{games}下钻到详情页通过收藏按钮来收藏。`,
  dbi_info_games: `游戏`,
  dbi_info_companies: `公司`,

  dbi_info_steam_metrics: 'Steam Metrics只能通过选择“Global”作为市场来获得。',
  dbi_info_download_full_data: `点击下载最近一个月的完整数据，包括设备、设备型号、设备品牌、设备类型、系统芯片、CPU 内核、CPU 时速、GPU 芯片、内存（GB）、显示屏尺寸、屏幕分辨率、电池容量、通信技术支持、国家代码（市场定义）。`,
  dbi_info_following_nodata: `当前筛选项内无数据，`,
  dbi_info_following_backto_orginal: `返回原始筛选器。`,
  dbi_info_following_echart_streaming_nodata: `该数据不分国家维度。`,
  dbi_info_following_echart_streaming_backto_orginal: `重置筛选器`,

  dbi_info_mobile_datasource_range:
    '仅提供AppStore和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据.',
  dbi_info_mobile_compare_datasource_range:
    'Sensor Tower和data.ai都仅提供AppStore和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。',

  dbi_info_revenue_metrics_category_disabled_tips:
    '线上收入、销量和付费玩家平均线上消费额只有美国德国西班牙英国和法国的数据，平均单笔交易消费额只有美国数据；零售收入只有美国的月粒度数据。',
  dbi_info_digital_revenue_metric_disabled_tips:
    '线上收入只有美国德国西班牙英国和法国的数据',
  dbi_info_units_metric_disabled_tips: '销量只有美国德国西班牙英国和法国的数据',
  dbi_info_digital_arppu_metric_disabled_tips:
    '付费玩家平均线上消费额只有美国的数据',
  dbi_info_ast_metric_disabled_tips:
    '平均单笔交易消费额只有美国德国西班牙英国和法国的数据',
  dbi_info_physical_revenue_metric_disabled_tips:
    '零售收入只有美国的月粒度数据。',
  dbi_info_physical_units_metric_disabled_tips:
    '零售销量只有美国的月粒度数据。',
  dbi_info_newzoo_metrics_category_disabled_tips:
    'No-update为月粒度数据并且在2024年5月停止更新。',
  dbi_info_databrain_game_nodata_tips:
    '该游戏暂无 DataBrain 数据。',
  dbi_info_newzoo_noupdate_metrics_category_disabled_tips:
    'Newzoo指标按照月粒度来更新数据的。',
  dbi_info_ampere_mau_category_disabled_tips:
    '其他数据源月活跃玩家数指标按照月粒度来更新数据的。',
  dbi_info_ampere_dau_category_disabled_tips:
    '其他数据源日活跃玩家数指标按照日粒度来更新数据的。',
  dbi_info_ampere_engagement_category_disabled_tips:
    '其他数据源活跃指标按照月粒度或日粒度来更新数据的。',
  dbi_info_ampere_other_vendor_category_disabled_tips:
    '其他数据源指标按照月粒度或日粒度来更新数据的。',
  dbi_info_ampere_retention_category_disabled_tips: '其他数据源留存指标按照日粒度来更新数据的。',
  dbi_info_other_vendor_disabled_tips: 'Other Vendor提供日粒度和月粒度的用户活跃度数据。',
  dbi_info_alinea_mau_metric_disabled_tips: '月活跃玩家数指标按照月粒度来更新数据的。',
  dbi_info_alinea_dau_metric_disabled_tips: '日活跃玩家数指标按照日粒度来更新数据的。',
  dbi_info_console_japan_sales_metrics_category_disabled_tips:
    '只有当选择日本且时间粒度为周时法米通数据才可以使用，它是来自console游戏的数据。',
  dbi_info_gsd_metrics_category_disabled_tips:
    'GSD数据是周粒度数据。', // GSD指标仅在时间筛选器为周粒度和国家筛选器为欧洲国家时可用。
  dbi_info_steam_data_metrics_category_disabled_tips: '只有PC游戏的全球数据。',
  dbi_info_vgi_metrics_category_disabled_tips:
    'VG Insights仅提供来自Steam平台的全球数据。',
  dbi_info_metric_not_checked_disabled_tips: '宽表下拉框没有选中该指标。',

  dbi_info_digital_revenue_right_icon_tips:
    '这里显示的是这款游戏的总收入，包括完整游戏付费扩展包、微交易等。数据包括美国、英国、德国、法国和西班牙。',
  dbi_info_us_digital_revenue_right_icon_tips:
    '这里显示的是这款游戏的总收入，包括完整游戏付费扩展包、微交易等。数据包括美国、英国、德国、法国和西班牙。如果调整国家筛选器则同步调整。',

  dbi_info_revenue_from_mscience_datasource_tips:
    '这里汇总了来自 Mscience(#{regions}) 的收入数据。',
  dbi_info_revenue_from_npd_datasource_tips:
    '这里汇总了 NPD(#{regions})的收入数据。',

  dbi_info_only_global_data: '仅有Global层面的数据',
  dbi_info_steam_global_only: `只有选择 "全球 "作为市场时，才能使用 Steam 指标。`,
  dbi_info_mscience_available_only:
    'Mscience 指标仅在选择美国、英国、法国、德国、西班牙时可用。',
  dbi_info_physical_monthly_only: '	NPD仅提供美国的月粒度数据。',
  dbi_info_newzoo_month_updated: newzooByMonth,

  dbi_info_data_report_disabled: '需要该报告请联系velvetjiang。',

  dbi_info_data_opinion_disabled:
    '当前游戏舆情未监控，如有监控需求请联系sophiaxwxu。',
  dbi_info_data_detail_tab_nodata_disabled: '当前模块暂时无数据。',

  dbi_info_metric_us_digitalrevenue:
    '由于美国的数据比较权威，这里我们默认展示美国数据。',
  dbi_info_metric_us_physicalrevenue: 'NPD只收录了美国地区的零售收入数据。',
  dbi_info_metric_us_digitalARPPU: '只提供美国地区的数据。',
  dbi_info_metric_global_mau:
    '用户活跃提供Global粒度的数据，包括37个国家的具体数值。',
  dbi_info_search_metric: '搜索表中的任意指标',
  dbi_info_metric_search_placeholder: '请输入指标名称 （例：收入）',
  dbi_info_segement_mscience:
    '该筛选器仅作用于 {mscienceIcon} mscience相关数据',
  dbi_info_vig_disabled: 'VGI指标仅在选择全球方案时可用。',
  dbi_info_famitsu_disabled: 'Famitsu指标仅在周粒度下可用。',
  dbi_info_gsd_disabled: 'GSD指标仅在周粒度下可用。',
  dbi_info_all_metrics_disabled: '可视化指标最多选择两个。',
  dbi_info_detail_genre_pc:
    'PC游戏的品类标签由GameResearch Center的专家团队，基于Steam平台的官方标签（Steam Tags）进行综合评定提供。',
  dbi_info_detail_genre_pc_console:
    'PC&Console游戏的品类标签由GameResearch Center的专家团队，基于Steam平台的官方标签（Steam Tags）并参考Riot Pixels等数据源进行综合评定提供。',
  dbi_info_detail_genre_console:
    'Console游戏的品类标签由GameResearch Center的专家团队，基于其同名PC游戏的Steam Tags并参考Riot Pixels的数据进行综合评定提供。',
  dbi_info_steamfollowers:
    '由Steam官方提供的该游戏的关注人数。日粒度数据取每日累计关注人数，月粒度数据取当月最后一天累计关注人数。',
  dbi_info_gamalytic__steamfollowers:
    '由Steam官方提供的该游戏的关注人数。日粒度数据取每日累计关注人数，月粒度数据取当月最后一天累计关注人数。',
  dbi_info_steamreviews: '此概要只使用从Steam直接购买游戏的消费者评测。',
  dbi_info_gamalytic__cumulative_reviews:
    '此概要只使用从Steam直接购买游戏的消费者评测。',
  dbi_info_allMetrics_nodatamsg: `当前筛选条件下无数据。<br/>请调整时间颗粒度、范围或国家筛选器查看更多数据。<br/>例如用户活跃数据仅月度更新，法米通仅提供周度日本区数据等。`,
  dbi_ifno_mergesummax: `表格中PCU、ACU数据取最大值，其他数据取总值。`,
  dbi_info_fortyday_nodatamsg: `当前筛选条件下无数据。因月粒度数据的更新延迟，对于上线前40天的游戏，请切换为日粒度查看如pcu、acu等数据。`,
  dbi_info_following_sum_mobile: `表格中DAU数据取最大值，商店排名取最高排名，商店评分取最大值，其他数据取总值。`,
  dbi_info_following_sum_pc: `表格中PCU数据取最大值，商店排名取最高排名，商店评分取最大值，其他数据取总值。`,
  dbi_info_following_sum_console: `表格中商店排名取最高排名，其他数据取总值。`,
  dbi_info_gsd_digitalRevenue: `游戏电子版收入。由头部发行商直接向GSD分享的数据。电子版收入有12周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。`,
  dbi_info_gsd_physicalRevenue: `游戏零售版收入。由头部发行商直接向GSD分享的数据。零售版收入仅1周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。`,
  dbi_info_gsd_digitalUnits: `游戏电子版销量。由头部发行商直接向GSD分享的数据。电子版销量仅1周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。`,
  dbi_info_gsd_physicalUnits: `游戏零售版销量。由头部发行商直接向GSD分享的数据。零售版销量仅1周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。`,
  dbi_info_store_rating_disabled_tips: `商店评分只有在单日下global范围内才可用。`,
  dbi_info_store_rating_disabled_tips_global: `MetaCritic评分只有日粒度全球数据。筛选一段时间会展示最新有数据的一天的数据。`,
  dbi_info_digital_revenue_tip_new:
    '由 MScience 提供的美国地区电子版游戏收入数据。{br}默认展示的数据为美国市场数据，这是由于美国市场的抽样数据量更为充分。而对于欧洲等市场，由于抽样数据量相对较小，分析时建议谨慎参考使用。',
  dbi_info_units_indicates_new: `"销量" 表示交易数量，类型为‘全部’的销量比其他部分的单位总和要小。因为单笔交易可能包括完整游戏和付费扩展包等。取所选时间段的总值。`,
  dbi_info_units_indicates_basegame: `指标含义:游戏线上销量，仅包含电子版游戏本体销量。取所选时间段的总值。`,
  dbi_info_allMetrics_nodata_msg_new:
    // `当前筛选条件下无数据。<br/>请调整<strong>日期颗粒度</strong>、<strong>日期范围</strong>或<strong>国家筛选器</strong>以查看数据。<br/>举例：GSD数据仅周粒度更新等。`,
    // `当前筛选条件下无数据。<br/>
    // 请调整<strong>日期颗粒度</strong>、<strong>日期范围</strong>或<strong>国家筛选器</strong>以查看数据。<br/>
    // 例如：GSD数据仅周粒度更新，Steam数据除玩家国家分布外的其他指标仅有全球数据，Mscience平台月粒度下有数据的游戏比日粒度的游戏多。<br/>
    // GSD线上收入数据有三个月的延迟。`
    `<p>当前筛选暂无数据，请调整日期颗粒度、时间范围或国家筛选器重试</p>
    <p><strong>数据源说明：</strong>GSD 数据源周更新，线上收入延迟 3 个月；Steam 除“玩家地域分布”数据外其他为全球口径；<br/>
   MScience 月粒度覆盖游戏多于日粒度。</p>
<p><strong>区域筛选说明：</strong>Steam 不支持分国家筛选；GSD、NPD、MScience 及其他渠道部分指标支持国家查询。</p>
    `,
  dbi_info_rank_trend_tip_desc: '如果游戏主体和DLC同时入榜，取最高排名。',
  dbi_info_rank_trend_mobile_tip_desc:
    '如果单榜单同时存在游戏的几个版本，取最高排名。',

  dbi_info_ampere_mau: `指标含义：月活跃用户{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,

// DataBrain校准 总收入（趋势）
  dbi_info_databrain_total_revenue_trends: `指标定义: 通过<strong>电子版线上购买和实体版线下销售</strong>获得的总收入，包括本体游戏、游戏内交易、预购和DLC，仅限全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总收入($)曲线进行趋势校准。{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合方式: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请随时联系zakirzheng。{br}`,

  dbi_info_databrain_total_revenue_trends_kpi: `指标定义: 通过<strong>电子版线上购买和实体版线下销售</strong>获得的总收入，包括本体游戏、游戏内交易、预购和DLC，仅限全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总收入($)曲线进行趋势校准。{br}{br}
    <a href="javascript:void(0)" style="color:#4096ff;text-decoration:underline;cursor:pointer" data-action="viewCalibrationData" data-metric="databrain__total_revenue">查看校准原始数据</a>（筛选器将切换为游戏上线至今）{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合方式: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请随时联系zakirzheng。{br}`,

// DataBrain校准 总收入（累计）
  dbi_info_databrain_lifetime_total_revenue: `指标定义: 自游戏上线以来通过<strong>电子版线上购买和实体版线下销售</strong>获得的总收入加总，包括本体游戏、游戏内交易、预购和DLC，仅限全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总收入($)曲线进行趋势校准。{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合逻辑: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请随时联系zakirzheng。{br}`,

  dbi_info_databrain_lifetime_total_revenue_kpi: `指标定义: 自游戏上线以来通过<strong>电子版线上购买和实体版线下销售</strong>获得的总收入加总，包括本体游戏、游戏内交易、预购和DLC，仅限全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总收入($)曲线进行趋势校准。{br}{br}
   <a href="javascript:void(0)" style="color:#4096ff;text-decoration:underline;cursor:pointer" data-action="viewCalibrationData" data-metric="databrain__lifetime_total_revenue">查看校准原始数据</a>（筛选器将切换为游戏上线至今）{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合逻辑: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请随时联系zakirzheng。{br}`,

// M Science 线上收入（累计）
  dbi_info_mscience_lifetime_total_revenue: `指标含义：自游戏发布以来的线上收入加总，包含电子版游戏本体、游戏内交易、预购、DLC。{br}{br}
    数据来源：M Science主要覆盖 🇺🇸美国数据，美国数据置信度高。部分游戏含有英、法、德、西四个国家数据，欧洲数据置信度较低。🌍 全球数据为五国加总数据。{br}{br}
    更新机制：时间粒度为日。延时6天（美国），延时7-14天（英、法、德、西）。每天在4:40PM UTC+0可以查看截至6天前（美国）与截至7-14天前（欧洲）的数据。{br}{br}
    数据聚合逻辑：取总值线上收入(美元){br}{br}
    时间段聚合方式：截至区间末的累计总值{br}{br}`,

  dbi_info_mscience_lifetime_units:
`
指标含义: 自游戏发布以来的游戏线上销量加总，包含电子版游戏拷贝、游戏内交易、预购、DLC。类型为"全部"的销量可能小于其他部分单位总和，单笔交易可能包含游戏拷贝和DLC等多个产品。{br}{br}
数据来源: M Science主要覆盖🇺🇸美国数据，美国数据置信度高。部分游戏含有英、法、德、西四个国家数据，欧洲数据置信度较低。🌍 全球数据为五国加总数据。{br}{br}
更新机制: 时间粒度为日。延时6天（美国），延时7-14天（英、法、德、西）, 每天的4:40PM UTC+0 可以看到日期截止6天前的数据（美国）和日期截止7-14天前的数据 （欧洲）。{br}{br}
数据聚合逻辑:取总值线上收入(美元)
`,

  dbi_info_mscience_lifetime_units_new:
`
指标含义: 自游戏发布以来的游戏线上销量加总，仅包含电子版游戏本体销量。{br}{br}
数据来源: M Science主要覆盖🇺🇸美国数据，美国数据置信度高。部分游戏含有英、法、德、西四个国家数据，欧洲数据置信度较低。🌍 全球数据为五国加总数据。{br}{br}
更新机制: 时间粒度为日。延时6天（美国），延时7-14天（英、法、德、西）, 每天的4:40PM UTC+0 可以看到日期截止6天前的数据（美国）和日期截止7-14天前的数据 （欧洲）。{br}{br}
数据聚合逻辑:取总值线上收入(美元)
`,

// DataBrain校准 基础版销量（趋势）
  dbi_info_databrain_total_units_basegame: `指标定义: 游戏本体销量，仅全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总销量曲线进行趋势校准。{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合逻辑: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请联系zakirzheng。{br}`,

  dbi_info_databrain_total_units_basegame_kpi: `指标定义: 游戏本体销量，仅全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总销量曲线进行趋势校准。{br}{br}
   <a href="javascript:void(0)" style="color:#4096ff;text-decoration:underline;cursor:pointer" data-action="viewCalibrationData" data-metric="databrain__base_game_sales_units">查看校准原始数据</a>（筛选器将切换为游戏上线至今）{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合逻辑: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请联系zakirzheng。{br}`,

// DataBrain校准 基础版销量（累计）
  dbi_info_databrain_lifetime_total_units: `指标定义: 自游戏发布以来游戏本体销量加总，仅全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总销量曲线进行趋势校准。{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合逻辑: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请联系zakirzheng。{br}`,

  dbi_info_databrain_lifetime_total_units_kpi: `指标定义: 自游戏发布以来游戏本体销量加总，仅全球数据，仅限PC&Console合并数据。{br}{br}
    数据来源: DataBrain校准数据，根据校准算法，基于真实数据进行数值校准，基于第三方数据源历史总销量曲线进行趋势校准。{br}{br}
   <a href="javascript:void(0)" style="color:#4096ff;text-decoration:underline;cursor:pointer" data-action="viewCalibrationData" data-metric="databrain__lifetime_base_game_sales_units">查看校准原始数据</a>（筛选器将切换为游戏上线至今）{br}{br}
    更新机制: 日粒度，延时7天。{br}{br}
    时间聚合逻辑: 取总值{br}{br}
    如对此数据有任何反馈或疑问，请联系zakirzheng。{br}`,
  dbi_info_ampere_previous_mau: `
    指标含义：月平均游玩时长 = 总游玩时长/月活跃用户{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_added_mau: `
    指标含义：上个月未玩过该游戏的月活跃用户数。{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_new_mau: `
    指标含义：自追踪数据以来未曾玩过该游戏的新进月活用户数。{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_retained_mau: `
    指标含义：上个月也玩过游戏的月活跃用户数。{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_churned_mau: `
    指标含义：指定月份中未在下个月继续玩游戏的用户数。此指标只能在下个月的数据收集完成后估算，因此无法获取最近一个月的数据。{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_dau: `
    指标含义：日活跃用户{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_new_dau: `
    指标含义：自追踪数据以来未曾玩过该游戏的新进日活用户数。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_avg_monthly_playtime: `
    指标含义：月平均游玩时长 = 总游玩时长/月活跃用户{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_acquisition_rate: `
    指标含义：上个月未玩过该游戏的月活跃用户总数的百分比。{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_stickiness: `
    指标含义：玩家每月平均游玩天数的百分比。{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取平均值{br}`,
  dbi_metric_ampere_lifetime_users: `
    指标含义：自发布以来或自 2022 年 5 月追踪数据以来至少玩过一次游戏的用户总数。Xbox、PS 和 Steam 分别自 2022 年 5 月、2022 年 8 月和 2023 年 5 月开始跟踪。{br}
    时间粒度：月{br}
    更新时间：每个月第一个完整周的周四{br}
    时间段计算方式：每月取最大值{br}`,
  dbi_metric_ampere_avg_dailly_playtime: `
    指标含义：所有用户玩当前游戏所花费的时间总和。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_info_ampere_d1: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，隔天再次游玩的玩家数量。
    {br}时间粒度：日
    {br}更新时间：每周六更新上周数据加额外1天延迟
    {br}时间段计算方式：总留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_info_ampere_d7: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第7天再次游玩的玩家数量。
    {br}时间粒度：日
    {br}更新时间：每周六更新上周数据加额外7天延迟
    {br}时间段计算方式：总留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_info_ampere_d14: `
  指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第14天再次游玩的玩家数量。
  {br}时间粒度：日
  {br}更新时间：每周六更新上周数据加额外14天延迟
  {br}时间段计算方式：总留存用户除以总新进用户
  {br}数据来源：其他数据源
  `,
  dbi_metric_info_ampere_d28: `
  指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第28天再次游玩的玩家数量。
  {br}时间粒度：日
  {br}更新时间：每周六更新上周数据加额外28天延迟
  {br}时间段计算方式：总留存用户除以总新进用户
  {br}数据来源：其他数据源
  `,
  dbi_metric_info_ampere_d60: `
  指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第60天再次游玩的玩家数量。
  {br}时间粒度：日
  {br}更新时间：每周六更新上周数据加额外60天延迟
  {br}时间段计算方式：总留存用户除以总新进用户
  {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_info_ampere_d1: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，隔天再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外1天延迟
    {br}时间段计算方式：总留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_info_ampere_d7: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，7天后再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外7天延迟
    {br}时间段计算方式：总留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_info_ampere_d14: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，14天后再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外14天延迟
    {br}时间段计算方式：总留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_info_ampere_d28: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第28天再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外28天延迟
    {br}时间段计算方式：总留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_info_ampere_d60: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第60天再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外60天延迟
    {br}时间段计算方式：总留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_ampere_d1: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第2天再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_d7: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第7天再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_d14: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第14天再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_d28: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第28天再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_d60: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第60天再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_rolling_d1: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第2天或之后再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_rolling_d7: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第7天或之后再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_rolling_d14: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第14天或之后再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_rolling_d28: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第28天或之后再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_ampere_rolling_d60: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第60天或之后再次游玩的玩家数量。{br}
    时间粒度：日{br}
    更新时间：每周四{br}
    时间段计算方式：每日取平均值{br}`,
  dbi_metric_monthly_ampere_rolling_d1: `
  指标含义：在首次登陆游戏（起始日设为Day0）的用户中，隔天或之后再次游玩的玩家数量。
  {br}时间粒度：月
  {br}更新时间：每个月第一个完整周的周六加额外1天延迟
  {br}时间段计算方式：总滚动留存用户除以总新进用户
  {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_ampere_rolling_d7: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第7天或之后再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外7天延迟
    {br}时间段计算方式：总滚动留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_ampere_rolling_d14: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第14天或之后再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外14天延迟
    {br}时间段计算方式：总滚动留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_ampere_rolling_d28: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第28天或之后再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外28天延迟
    {br}时间段计算方式：总滚动留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_metric_monthly_ampere_rolling_d60: `
    指标含义：在首次登陆游戏（起始日设为Day0）的用户中，第60天或之后再次游玩的玩家数量。
    {br}时间粒度：月
    {br}更新时间：每个月第一个完整周的周六加额外60天延迟
    {br}时间段计算方式：总滚动留存用户除以总新进用户
    {br}数据来源：其他数据源
  `,
  dbi_info_mentions_info:
    '声量：全网抓取到的玩家帖子和评论数汇总。包括游戏在游戏商店下的所有评论，以及通过监控词和官号在社交媒体上抓取到的评论。',
  dbi_info_brand_health_info:
    '品牌健康度：基于情感分对不同渠道和不同有效性评论进行加权计算，变化趋势对于游戏正负事件更敏感。分数从-100到100，越高表示舆情反馈越积极。',
  dbi_info_mobile_demographics_download_time_setting_info:
    'Multiple months can be selected at once. Data will be exported separately by month.',
  dbi_info_mobile_demographics_countries_time_setting_info:
    'Multiple countries can be selected at once. Data will be exported separately by country.',
  dbi_info_companies_download_modal_time_settings:
    'Data metrics which provided by NPD is only avaliable in month granularity,Mscience provides daily metrics for partial top PC/Console games only.',
  dbi_info_mobile_time_settings_info: '活跃用户指标有不同的粒度，选择以下选项可获得 DAU/WAU/MAU。',
  dbi_info_daily_wishlist: `
    指标含义：Daily Wishlist指游戏单天的新增愿望单人数。当前提供净wishlist人数，减去任何已经转化为游戏销量或自添加以来已被删除的愿望清单数量。{br}
    时间粒度：日{br}
    更新时间：每日更新一次。通常为6 PM UTC +2{br}
    时间段计算方式：所选时段范围内多天数据取Sum值。`,
  dbi_info_daily_wishlist_after_launch:
    '游戏上线后，Steam 将不再更新总愿望单、日新增愿望单数据。',
  dbi_info_lifetime_wishlist: `
    指标含义：Total Wishlist指游戏截至所需按日期的总愿望单人数。当前提供净wishlist人数，减去任何已经转化为游戏销量或自添加以来已被删除的愿望清单数量。{br}
    时间粒度：日{br}
    更新时间：每日更新一次。通常为6 PM UTC +1{br}
    时间段计算方式：所选时段范围内多天数据取最新一天的值。`,
  dbi_info_gamalytic__lifetime_wishlist: `
    指标含义：Total Wishlist指游戏截至所需按日期的总愿望单人数。当前提供净wishlist人数，减去任何已经转化为游戏销量或自添加以来已被删除的愿望清单数量。{br}
    时间粒度：日{br}
    时间段计算方式：所选时段范围内多天数据取最新一天的值。{br}
  `,
  dbi_info_gamalytic__playtime: `每位玩家在这款游戏上花费的总平均时间（小时）。`,
  dbi_info_source_steam_pcu: 'PCU是最高同时在线玩家人数。数据源爬取从2025年2月开始。',
  dbi_info_source_steam_acu: 'ACU是平均同时在线玩家人数。数据源爬取从2025年2月开始。',
  // Alinea 数据源 hover 文案，参照 Gamalytic 写法，内容由产品提供
  dbi_info_alinea_est_revenue: `Steam游戏收入(美元)，根据Steam真数节点和公开信息等数据进行估算，涵盖预售在内的游戏本体及DLC拓展包及MTX内购等全部GaaS相关收入。`,
  dbi_info_alinea_est_cumulative_revenue: `Steam游戏总收入(美元)，根据Steam真数节点和公开信息等数据进行估算，涵盖预售在内的游戏本体及DLC拓展包及MTX内购等全部GaaS相关收入。`,
  dbi_info_alinea_est_units: `根据Steam评论估算，只提供Steam游戏销量。这里仅提供完整游戏的销量，因此付费游戏的数据可信度相对高于免费游戏。可参考Mscience提供的电子版收入来查看单款游戏的整体销售数据，这些数据可以按照完整游戏、微交易、付费扩展包等不同细分来划分。`,
  dbi_info_alinea_est_cumulative_units: `游戏自发行以来在Steam平台的总销量。`,
  dbi_info_alinea_pcu: 'PCU是最高同时在线玩家人数。取所选时间段内最大值。',
  dbi_info_alinea_acu: 'ACU是平均同时在线用户。取所选时间段内的平均值。',
  dbi_info_alinea__steamfollowers: '该游戏的关注人数。日粒度数据取每日累计关注人数，月粒度数据取当月最后一天累计关注人数。',
  dbi_info_alinea__steamreviews: '此概要只使用从Steam直接购买游戏的消费者评测。',
  dbi_info_alinea__cumulative_reviews:
    '此概要只使用从Steam直接购买游戏的消费者评测。',
  dbi_info_alinea__players:
    '预估至少游玩过一次该游戏的用户数量，该预估值包含未付费用户。',
  dbi_info_alinea__players_total:
    '预估至少游玩过一次该游戏的总用户数量，该预估值包含未付费用户。',
  dbi_info_alinea__positive:
    '当前统计周期内，有游玩记录用户产生的好评评测数。',
  dbi_info_alinea__cumulative_positive:
    '游戏上线至今，所有有游玩记录用户提交的好评评测累计总数。',
  dbi_info_alinea_est_price: '该游戏的每日价格（美元），如果选择周或月，则取平均值。',
  dbi_info_alinea__lifetime_weighted_price: 'Weighted Price指以游戏每日销量加权的价格。',
  dbi_info_alinea__players_by_country: '玩家在不同国家/地区的数量分布。',
  dbi_info_alinea__wishlists_by_country: '展示玩家在不同国家/地区的愿望单数量分布。',
  dbi_info_alinea__daily_wishlist: `
    指标含义：Daily Wishlist指游戏单天的新增愿望单人数。当前提供净wishlist人数，减去任何已经转化为游戏销量或自添加以来已被删除的愿望清单数量。{br}
    时间粒度：日{br}
    更新时间：每日更新一次。通常为6 PM UTC +2{br}
    时间段计算方式：所选时段范围内多天数据取Sum值。`,
  dbi_info_alinea__wishlists: '指定日期新增愿望单人数。',
  dbi_info_alinea__lifetime_wishlist: `Total Wishlist指游戏截至所需按日期的总愿望单人数。当前提供净wishlist人数，减去任何已经转化为游戏销量或自添加以来已被删除的愿望清单数量。时间段计算方式：所选时段范围内多天数据取最新一天的值。`,
  dbi_info_alinea__dau: '日活跃用户',
  dbi_info_alinea__mau: '月活跃用户',
  dbi_info_alinea__playtime: '每位玩家在这款游戏上花费的总平均时间（分钟）。',
  dbi_info_alinea__total_followers: `由Steam官方提供的该游戏的关注人数。日粒度数据取每日累计关注人数，月粒度数据取当月最后一天累计关注人数。`,
  // Alinea PlayStation hover 文案
  dbi_info_alinea_ps_revenue: `扣除增值税、PlayStation 平台分成前的预估收入，已核算折扣优惠；付费游戏仅统计游戏本体销售收入。`,
  dbi_info_alinea_ps_revenue_total: `扣除增值税、PlayStation 平台分成前的全周期累计预估收入，已核算折扣优惠；付费游戏仅统计游戏本体销售收入。`,
  dbi_info_alinea_ps_units: `预估在 PS 平台付费购入游戏的用户份数，包含数字版与终端玩家到手实体盘，不含经销商铺货出货数据。`,
  dbi_info_alinea_ps_units_total: `PS 平台全周期累计付费购入游戏的用户份数，包含数字版与终端玩家到手实体盘，不含经销商铺货出货数据。`,
  dbi_info_alinea_ps_lifetime_players: `PS 平台至少游玩一次的预估用户，含买断购买、PS Plus 领取、账号共享游玩用户；统计所有渠道获得游戏权限的玩家。`,
  dbi_info_alinea_ps_plus_total_players: `通过 PS Plus 权益领取并游玩游戏的全周期累计预估用户数。`,
  dbi_info_alinea_ps_game_pass_players: `通过 PS Plus 权益领取并游玩游戏的预估新增用户数。`,
  dbi_info_alinea_ps_game_pass_players_total: `通过 PS Plus 权益领取并游玩游戏的全周期累计预估用户数。`,
  dbi_info_alinea_ps_dau: `所选周期内 PlayStation 平台每日至少游玩一次游戏的预估独立用户数。`,
  dbi_info_alinea_ps_mau: `所选自然月内 PlayStation 平台至少游玩一次游戏的预估独立用户数。`,
  dbi_info_alinea_ps_players_by_country: `PlayStation 平台游戏玩家主要分布国家统计数据。`,
  dbi_info_alinea_ps_price: `游戏在 PlayStation 平台的当前在售定价（美元）`,
  // Alinea Xbox hover 文案
  dbi_info_alinea_xbox_revenue: `扣除增值税、Xbox 平台分成前预估收入，已计入折扣，付费游戏仅统计本体销售收入。`,
  dbi_info_alinea_xbox_revenue_total: `扣除增值税、Xbox 平台分成前全周期累计预估收入，已计入折扣，付费游戏仅统计本体销售收入。`,
  dbi_info_alinea_xbox_units: `Xbox 平台付费购买游戏预估份数，包含 Xbox 商店数字版销量。`,
  dbi_info_alinea_xbox_units_total: `Xbox 平台全周期累计付费购买游戏份数，包含 Xbox 商店数字版销量。`,
  dbi_info_alinea_xbox_players: `Xbox 平台至少游玩一次的预估用户，包含买断购入与 XGP 订阅游玩用户。`,
  dbi_info_alinea_xbox_game_pass_total_players: `通过 XGP 订阅（主机版 / PC 版 / 终极版）游玩游戏的预估用户数。`,
  dbi_info_alinea_xbox_game_pass_players: `通过 XGP 订阅（主机版 / PC 版 / 终极版）游玩游戏的预估新增用户数。`,
  dbi_info_alinea_xbox_game_pass_players_total: `通过 XGP 订阅（主机版 / PC 版 / 终极版）游玩游戏的预估总用户数。`,
  dbi_info_alinea_xbox_dau: `所选周期内 Xbox 平台每日至少游玩一次游戏的预估独立用户数。`,
  dbi_info_alinea_xbox_mau: `所选自然月内 Xbox 平台至少游玩一次游戏的预估独立用户数。`,
  dbi_info_alinea_xbox_price: `游戏在 Xbox 平台的当前在售定价（美元）`,
  // Mobile 筛选器 Hover 文案
  dbi_info_mobile_filter_my_filter_hover: `保存并一键复用常用筛选组合。`,
  dbi_info_mobile_filter_range_time_hover: `切换日、周、月等时间粒度，查看对应周期数据。`,
  dbi_info_mobile_filter_region_hover: `按全球、国家或地区筛选手游市场数据。`,
  dbi_info_mobile_filter_platform_hover: `按移动设备系统或应用商店平台筛选手游数据。`,
  dbi_info_mobile_filter_genre_hover: `品类标签覆盖自 2020 年以来主要市场累计收入贡献前 85%、全球累计收入贡献前 92% 的游戏。`,
  dbi_info_mobile_filter_all_games_hover: `选择一个或多个手游，定向分析单品表现。`,
  dbi_info_mobile_filter_data_source_hover: `切换手游指标的数据来源与统计口径。`,
  dbi_info_mobile_filter_company_hover: `按研发商或发行商筛选其旗下手游。`,
  dbi_info_mobile_filter_release_time_hover: `按游戏发布日期筛选；仅在适用时间范围内生效。`,
  dbi_info_mobile_filter_revenue_scope_net_hover: `按扣除平台分成后的净收入统计。`,
  dbi_info_mobile_filter_revenue_scope_gross_hover: `按用户实际支付总额统计，包含平台分成。`,
  dbi_info_mobile_filter_active_users_range_hover: `按活跃用户规模区间筛选游戏热度层级。`,
  dbi_info_mobile_filter_revenue_range_hover: `按所选周期内收入区间筛选游戏。`,
  dbi_info_mobile_filter_arpu_range_hover: `按用户平均收入区间筛选商业化效率相近的手游。`,
  dbi_info_mobile_filter_downloads_range_hover: `按所选周期内下载量区间筛选新增规模。`,
  dbi_info_mobile_filter_rpd_range_hover: `按所选周期内RPD区间筛选游戏。`,
  dbi_info_mobile_filter_d2_range_hover: `按所选周期内D2区间筛选游戏。`,
  dbi_info_mobile_filter_d3_range_hover: `按所选周期内D3区间筛选游戏。`,
  dbi_info_mobile_filter_d7_range_hover: `按所选周期内D7区间筛选游戏。`,
  dbi_info_mobile_filter_d15_range_hover: `按所选周期内D15区间筛选游戏。`,
  dbi_info_mobile_filter_d31_range_hover: `按所选周期内D31区间筛选游戏。`,
  dbi_info_mobile_filter_revenue_growth_hover: `按收入增长率区间筛选增长或下滑的游戏。`,
  dbi_info_mobile_filter_sensor_tower_art_style_hover: `按 Sensor Tower 定义的美术风格标签筛选手游。`,
  dbi_info_mobile_filter_sensor_tower_camera_pov_hover: `按 Sensor Tower 定义的画面镜头视角标签筛选手游。`,
  dbi_info_mobile_filter_sensor_tower_product_model_hover: `按 Sensor Tower 定义的游戏形态与模式标签筛选手游。`,
  dbi_info_mobile_filter_sensor_tower_setting_hover: `按 Sensor Tower 定义的世界观、背景或场景设定标签筛选手游。`,
  dbi_info_mobile_filter_sensor_tower_tags_hover: `按 Sensor Tower 的通用玩法、机制与产品特征标签筛选手游。`,
  dbi_info_mobile_filter_sensor_tower_theme_hover: `按 Sensor Tower 定义的题材与故事主题标签筛选手游。`,
  dbi_info_mobile_filter_sensor_tower_monetization_hover: `按 Sensor Tower 定义的商业化与付费模式标签筛选手游。`,
  dbi_info_mobile_filter_appmagic_themes_hover: `按 App Magic 定义的题材与世界观主题标签筛选手游。`,
  dbi_info_mobile_filter_appmagic_features_hover: `按 App Magic 提炼的核心玩法与特色机制标签筛选手游。`,
  dbi_info_mobile_filter_appmagic_ip_hover: `按 App Magic 标识的 IP 衍生、授权或改编属性标签筛选手游。`,
  dbi_info_mobile_filter_appmagic_settings_hover: `按 App Magic 定义的背景、世界与场景设定标签筛选手游。`,
  dbi_info_mobile_filter_appmagic_art_styles_hover: `按 App Magic 定义的视觉画风与美术表现标签筛选手游。`,
  dbi_info_mobile_filter_game_engine_hover: `按开发所用引擎类型筛选游戏。`,
  // PC & Console 筛选器 Hover 文案
  dbi_info_pcconsole_filter_my_filter_hover: `保存并一键复用常用筛选组合。`,
  dbi_info_pcconsole_filter_range_time_hover: `支持周粒度或自定义时间区间筛选，展示区间内游戏数据。`,
  dbi_info_pcconsole_filter_region_hover: `筛选全球、大洲及细分地区的 PC/console 游戏数据。`,
  dbi_info_pcconsole_filter_platform_hover: `按 PC 客户端、主机硬件或对应平台渠道筛选游戏。`,
  dbi_info_pcconsole_filter_genre_hover: `品类标签覆盖自 2020 年以来主要市场累计收入贡献前 85%、全球累计收入贡献前 92% 的游戏。`,
  dbi_info_pcconsole_filter_all_games_hover: `选择一个或多个 PC/console 游戏，定向分析单品表现。`,
  dbi_info_pcconsole_filter_company_hover: `按研发商或发行商筛选其旗下 PC/console 游戏。`,
  dbi_info_pcconsole_filter_digital_range_hover: `按 MScience 口径筛选数字版线上收入区间。`,
  dbi_info_pcconsole_filter_pcu_range_hover: `按 Steam 峰值同时在线人数筛选热度层级。`,
  dbi_info_pcconsole_filter_premium_range_hover: `按 Steam 付费本体销售收入区间筛选游戏。`,
  dbi_info_pcconsole_filter_steam_tag_hover: `按 Steam 官方品类标签筛选游戏。`,
  dbi_info_pcconsole_filter_game_mode_hover: `按单人、多人、合作等 Steam 游戏模式标签筛选。`,
  dbi_info_pcconsole_filter_price_range_hover: `按 Steam 商店付费游戏定价区间筛选。`,
  dbi_info_pcconsole_filter_gsd_segment_hover: `使用 GSD 数据，包含发行商分享数据与公开零售数据。`,
  dbi_info_pcconsole_filter_physical_range_hover: `按 NPD 口径筛选主机实体零售收入区间。`,
  dbi_info_pcconsole_filter_game_engine_hover: `按 PC/console 游戏开发所用引擎类型筛选。`,
  dbi_info_pcconsole_filter_publisher_class_hover: `基于 Gamalytics、Alinea 与 MScience 的发行商累计收入估算进行分层；取各数据源最高估算值，以降低单一数据源覆盖不足带来的偏差。覆盖 PC 市场收入，每周更新。`,
  dbi_info_pcconsole_filter_publisher_region_hover: `按发行商所在地或主要运营地区筛选其旗下游戏。`,
  dbi_info_pcconsole_filter_developer_hover: `按开发商或工作室筛选其开发的游戏。`,
  dbi_info_pcconsole_filter_wishlists_range_hover: `按玩家愿望单数量区间筛选对应热度的游戏。`,
};
// 此文档 新增请改dbi_info_为前缀
